/*-----------Types of SMS actions--------*/
/*---SEND SMS----*/
export const SMS_SEND_SUCCESS = "SMS_SEND_SUCCESS";
export const SMS_SEND_FAILED = "SMS_SEND_FAILED";
export const SMS_IS_SENDING = "SMS_IS_SENDING";